import { render, staticRenderFns } from "./node_menu.vue?vue&type=template&id=71a84569&"
import script from "./node_menu.vue?vue&type=script&lang=js&"
export * from "./node_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports